import axios from "axios";

export const COURSE_URL = "/Course";

/** Belli Bir Ders Listesini Elde Eder */
export function getCourses(queryParams) {
  return axios.post(`${COURSE_URL}/GetCourses`, queryParams);
}

/** Belli Bir Ders Listesini Sayfalama Olmadan Elde Eder */
export function getAllCourses(queryParams) {
  return axios.post(`${COURSE_URL}/GetAllCourses`, queryParams);
}

/** Yeni Bir Ders Elde Eder */
export function getNewCourse() {
  return axios.get(COURSE_URL);
}

/** Yeni Bir Alt Ders Elde Eder */
export function getNewSubCourse(parentId) {
  return axios.get(`${COURSE_URL}/GetNewSubCourse/${parentId}`);
}

/** Belli Bir Dersi Elde Eder */
export function getCourse(id) {
  return axios.get(`${COURSE_URL}/${id}`);
}

/** Belli Bir Dersi Kaydeder */
export function saveCourse(course) {
  return axios.post(COURSE_URL, course);
}

/** Belli Bir Ders Listesini Siler */
export function deleteCourses(ids) {
  return axios.post(`${COURSE_URL}/Delete`, ids);
}